import { AnnotationStatus } from "@models/annotation-status.enum";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { HighlightColor } from "src/app/components/review/redaction-annotation/highlight-color.model";
import { RedactionAnnotationEdit } from "src/app/components/review/redaction-annotation/redaction-annotation-edit.model";
import { RedactionAnnotation } from "src/app/components/review/redaction-annotation/redaction-annotation.model";

export const annotationEditorActions = createActionGroup({
	source: 'Annotation Editor',
	events: {
		'Initialize': props<{ docId: string, status: AnnotationStatus, isProcessing: boolean, totalPages: number }>(),
		'Get Annotations': props<{ docId: string }>(),
		'Annotations Loaded': props<{ annotations: RedactionAnnotationEdit[] }>(),
		'Update Annotations For Current Page': props<{ annotations: RedactionAnnotationEdit[] }>(),
		'Processing Started': emptyProps(),
		'Processing Stopped': props<{ status: AnnotationStatus }>(),
		'Go To Page': props<{ pageNum: number }>(),
		'Create Image': emptyProps(),
		'Image Created': props<{ status: AnnotationStatus }>(),
		'Create Annotated PDF': emptyProps(),
		'Annotated PDF Created': props<{ status: AnnotationStatus }>(),
		'Get Annotation Colors': emptyProps(),
		'Annotation Colors Loaded': props<{ colors: HighlightColor[] }>(),
		'Mark Editor Dirty': emptyProps(),
		'Mark Editor Clean': emptyProps(),
		'Set File Id List': props<{ items: Record<number, string> }>(),
		'View Annotated PDF File': props<{ docId: string }>(),
		'Reset Annotations For Current Doc': props<{ docId: string }>(),
		'Get Annotation Status': props<{ docId: string }>(),
		'Annotation Status Loaded': props<{ status: AnnotationStatus }>()
	},
});

export const currentAnnotationActions = createActionGroup({
	source: 'Annotation Edit Box',
	events: {
		'Set Current Annotation': props<{ annotationId: number }>(),
		'Create Annotation': props<{ annotation: RedactionAnnotation }>(),
		'Update Annotation': props<{ annotation: RedactionAnnotationEdit }>(),
		'Delete Annotation': props<{ annotationId: number }>(),
		'Set Annotation Text': props<{ text: string }>(),
		'Set Color Id': props<{ colorId: string }>()
	},
});